<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path data-follow-fill="currentColor" d="M790.211 178.146H512v.055H233.789c-17.226-.028-27.55-5.87-27.822-2.826v-25.05c0-15.35 12.498-27.82 27.822-27.82h612.065c15.377 0 27.821-12.443 27.821-27.822s-12.443-27.821-27.821-27.821H233.789c-44.116 0-79.973 34.505-82.9 77.894h-.564v728.92c0 46.024 37.438 83.463 83.464 83.463H790.21c46.025 0 83.464-37.438 83.464-83.464V247.726c0-38.363-37.44-69.58-83.464-69.58zm27.821 695.528c0 15.35-12.498 27.822-27.822 27.822H233.79c-15.323 0-27.822-12.471-27.822-27.822V230.498c8.677 2.027 17.908 3.345 27.822 3.345H512v-.054h278.211c17.008 0 27.822 9.155 27.822 13.937v625.948z" :fill="_fill" />
      <path data-follow-fill="currentColor" d="M607.625 582.13c26.738-23.61 43.97-57.74 43.97-96.131 0-70.993-57.762-128.727-128.727-128.727S394.14 415.006 394.14 485.999c0 36.423 15.347 69.196 39.738 92.64-66.167 31.516-112.335 98.511-112.335 176.55 0 15.378 12.444 27.822 27.822 27.822s27.822-12.443 27.822-27.821c0-77.405 62.978-140.383 140.355-140.383s140.355 62.979 140.355 140.384c0 15.377 12.443 27.821 27.822 27.821s27.821-12.443 27.821-27.821c0-75.432-43.298-140.299-105.916-173.06zm-84.757-169.216c40.319 0 73.084 32.793 73.084 73.085 0 40.32-32.766 73.112-73.084 73.112s-73.085-32.793-73.085-73.112c0-40.292 32.765-73.085 73.085-73.085z" :fill="_fill" />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1.4em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
